
import axios from "axios";
import { debounce } from 'lodash';
import React, { useState } from 'react';
import styled from "styled-components";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';


const StyledAutocomplete = styled(Autocomplete)`
  .MuiTextField-root {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export default function DaDataGeocodeAutocomplete({value, onChange, textFieldProps}) {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleChange = (e, value) => {
    onChange(value);
    setOptions([]);
  };

  const loadOptions = async (search) => {
    setLoading(true);
    let results = [];
    const load = async () => {
      return axios.get('dadata-suggestion-address', {
        params: {geocode: search}
      }).then(res => {
        res.data.suggestions.forEach(result => {
          results.push({
            address: result.value,
            lat: result.data.geo_lat,
            lon: result.data.geo_lon,
          })
        })
      });
    };

    await load();

    setLoading(false);
    setOptions(results);
  };

  const handleInputBlur = (e, value) => {
    onChange(e.target.value);
  }

  const handleInputChange = (e, value, reason) => {
    if (reason === 'input') {
      loadOptions(value);
    }
  }

  const debouncedOnChange = debounce(handleInputChange, 1000);

  const getOptionLabel = (option) => {
    return typeof option === 'string' ? option : option['address']
  }

  return (
    <StyledAutocomplete
      freeSolo
      options={options}
      loading={loading}
      value={value}
      noOptionsText={'Ничего не найдено'}
      loadingText={'Поиск адреса...'}
      selectOnFocus={true}
      getOptionLabel={getOptionLabel}
      autoHighlight={false}
      autoComplete={true}
      filterOptions={(options, state) => options}
      onInputChange={debouncedOnChange}
      onChange={(e, newValue) => handleChange(e, newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          margin="normal"
          multiline={true}
          variant="outlined"
          {...textFieldProps}
          onBlur={(e) => handleInputBlur(e)}
        />
      )}
    />
  )
}

